import { useEffect, useMemo } from 'react';
import { useOrganListenerContext } from '../../providers/OrganListenerContextProvider';
import { useOperatorContext } from '../login/OperatorContextProvider';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import { useWebSocketContext } from '../../providers/WebSocketContextProvider';
import './AccountInfo.css'

export default function AccountInfo() {
  const {operator} = useOperatorContext();
  const {isWebSocketReady, webSocketState} = useWebSocketContext();
  const {myAccountData} = useOrganListenerContext();
  const {sendMessage} = useWebSocketCaller();

  useEffect(()=>{
    if (isWebSocketReady()) {
      sendMessage('get-account-info', ({
        accountId: operator?.accountId,
        username: operator?.username
      }));
    }
  }, [webSocketState, sendMessage, isWebSocketReady, operator?.username, operator?.accountId]);

  // Render
  return useMemo( () =>  
    <div className='accountInfo'>       
      {myAccountData?.name}
    </div>, [myAccountData]
  );
}